import {
  CreateBillToManufacturerRequest,
  UpdateBillToManufacturerRequest
} from "../api/system/billToManufacturers";

export class EditBillToManufacturerModel {
  id: number = null;
  manufacturerCode: string;
  billTo: string;
  visible: boolean = true;
  saving: boolean = false;

  get isNew(): boolean {
    return !this.id;
  }

  toCreateRequest(): CreateBillToManufacturerRequest {
    return { billTo: this.billTo, manufacturerCode: this.manufacturerCode };
  }

  toUpdateRequest(): UpdateBillToManufacturerRequest {
    return { id: this.id, billTo: this.billTo, manufacturerCode: this.manufacturerCode };
  }
}
